var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"snipcart-checkout icons clickable",attrs:{"href":"#"},on:{"click":_vm.trackClick}},[_c('i',{staticClass:"ti-shopping-cart",staticStyle:{"font-size":"24px"}}),_vm._v(" "),_c('span',{staticClass:"snipcart-total-price"},[_vm._v("$0.00")]),_vm._v("\n  ("),_c('span',{staticClass:"snipcart-items-count"},[_vm._v("0")]),_vm._v(")\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bbed456","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartButton.vue
// module id = null
// module chunks = 